"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _CwDraggablePod = _interopRequireDefault(require("./CwDraggablePod.scss"));

var _classnames = _interopRequireDefault(require("classnames"));

var _IconPath = _interopRequireDefault(require("../../utils/IconPath"));

var _CwButton = _interopRequireDefault(require("../cwbutton/CwButton"));

var CwDraggablePod =
/*#__PURE__*/
function (_React$PureComponent) {
  (0, _inherits2.default)(CwDraggablePod, _React$PureComponent);

  function CwDraggablePod(props) {
    var _this;

    (0, _classCallCheck2.default)(this, CwDraggablePod);
    _this = (0, _possibleConstructorReturn2.default)(this, (0, _getPrototypeOf2.default)(CwDraggablePod).call(this, props));
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "getTitle", function () {
      var _this$props = _this.props,
          title = _this$props.title,
          ghostTitle = _this$props.ghostTitle,
          titleElements = _this$props.titleElements,
          isCollapsed = _this$props.isCollapsed,
          canDrag = _this$props.canDrag;

      if (title || ghostTitle || titleElements) {
        return _react.default.createElement("div", {
          className: (0, _classnames.default)(_CwDraggablePod.default.baseHeaderDyn, isCollapsed ? _this.state.animatePod ? _CwDraggablePod.default.headerDynAnimateCollapse : _CwDraggablePod.default.headerDynCollapse : _this.state.animatePod ? _CwDraggablePod.default.headerDynAnimateExpand : _CwDraggablePod.default.headerDynExpand),
          style: {
            cursor: canDrag ? 'move' : 'default'
          }
        }, _react.default.createElement("div", {
          className: (0, _classnames.default)(_CwDraggablePod.default.headerTextDyn, (0, _defineProperty2.default)({}, _CwDraggablePod.default.ghostTitleDyn, ghostTitle))
        }, ghostTitle ? 'pods are lame' : title), _this.collapseExpandButton(), titleElements);
      }

      return null;
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "collapseExpandButton", function () {
      return _this.props.isCollapsible ? _react.default.createElement("div", {
        key: _this.props.podID + '_collapse',
        className: _CwDraggablePod.default.expandCollapseButton
      }, _react.default.createElement(_CwButton.default, {
        cwId: 'btn_collapse',
        isStandard: false,
        icon: _this.props.isCollapsed ? _IconPath.default.get('Action_Expand') : _IconPath.default.get('Action_Collapse'),
        onClick: function onClick() {
          return _this.props.collapseButtonCallback();
        }
      })) : null;
    });
    _this.state = {
      animatePod: false
    };
    return _this;
  }

  (0, _createClass2.default)(CwDraggablePod, [{
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      if (this.props.isCollapsed !== prevProps.isCollapsed) {
        this.setState({
          animatePod: true
        });
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var _this$props2 = this.props,
          cwId = _this$props2.cwId,
          nested = _this$props2.nested,
          children = _this$props2.children,
          isCollapsed = _this$props2.isCollapsed;
      return _react.default.createElement("div", {
        "data-cwid": cwId,
        id: 'pod-' + this.props.podID,
        className: (0, _classnames.default)((0, _defineProperty2.default)({}, _CwDraggablePod.default.nestedDyn, nested))
      }, this.getTitle(), _react.default.createElement("div", {
        onAnimationEnd: function onAnimationEnd() {
          return _this2.setState({
            animatePod: false
          });
        },
        className: isCollapsed ? this.state.animatePod ? _CwDraggablePod.default.animateCollapse : _CwDraggablePod.default.collapsed : this.state.animatePod ? _CwDraggablePod.default.animateExpand : _CwDraggablePod.default.expand
      }, children));
    }
  }]);
  return CwDraggablePod;
}(_react.default.PureComponent);

;
CwDraggablePod.propTypes = {
  /**
   * Connectwise element id to be used as unique identifier
   */
  cwId: _propTypes.default.string,

  /**
   * Unique id used to identify pod
   */
  podID: _propTypes.default.string.isRequired,

  /**
   * Optional text to display in title bar
   */
  title: _propTypes.default.string,

  /**
   * True to include pod title spacing without any text
   * This is used to align pods when they're next to each other
   */
  ghostTitle: _propTypes.default.bool,

  /**
   * Array of elements to render next to pod title
   */
  titleElements: _propTypes.default.arrayOf(_propTypes.default.element),

  /**
   * Whether the pod is nested within another element, such as a grid, and requires indentation.
   */
  nested: _propTypes.default.bool,

  /**
   * is collapsible?
   */
  isCollapsible: _propTypes.default.bool,

  /**
   * Is pod collapsed?
   */
  isCollapsed: _propTypes.default.bool,

  /**
   * callback on expand/collapse click
   */
  collapseButtonCallback: _propTypes.default.func,

  /**
   * can pod drag?
   */
  canDrag: _propTypes.default.bool,

  /**
   * Pod body content
   */
  children: _propTypes.default.oneOfType([_propTypes.default.element, _propTypes.default.arrayOf(_propTypes.default.element)])
};
var _default = CwDraggablePod;
exports.default = _default;